import { Map } from "pages/user/MapPage/sections/Map"
import { useState } from "react"
import { useLocation } from "react-router-dom"
import styled from "styled-components"

export const MapSection = ({ query, nbrClasses, classes }) => {
  const { state } = useLocation()
  const coordinates = state?.coordinates
  const [mapCenter, setMapCenter] = useState(coordinates)

  //   if (!coordinates) return null

  return (
    <MapWrapper>
      <Map
        typeOfClass={query}
        location={coordinates}
        classes={classes}
        setMapCenter={setMapCenter}
      />
    </MapWrapper>
  )
}

const MapWrapper = styled.div`
  min-height: 400px;
  border-radius: 16px;
  overflow: hidden;
  padding-bottom: 1rem;

  & > div {
    padding-block: 0;
    height: 100%;

    & > h2 {
      display: none;
    }
  }

  .mapboxgl-map {
    border-radius: 16px;
  }
`
